import { SVGProps, Ref, forwardRef, memo } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_17299_3616)">
      <path
        d="M10.711 7.17873C10.362 8.1676 9.72815 9.03107 8.88918 9.66021C8.05031 10.2894 7.04392 10.6562 5.99689 10.7143C5.02902 10.7145 4.08455 10.4167 3.29177 9.86147C2.49899 9.3063 1.89633 8.52049 1.56563 7.61086M1.28279 4.82171C1.94277 3.01464 3.96982 1.28613 5.99689 1.28613C6.96948 1.28887 7.91741 1.59236 8.71072 2.155C9.50409 2.71765 10.1039 3.5119 10.4282 4.42887M11.2609 8.91073C11.1104 8.19908 10.9901 7.82012 10.7121 7.18207C10.0305 7.32299 9.65152 7.44333 8.98338 7.7309M0.869873 3.06266C0.967322 3.78353 1.05922 4.17035 1.28928 4.82722C1.97942 4.73713 2.36622 4.64515 3.05385 4.4078"
        stroke="#383838"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_17299_3616">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
const IconUpdateArrow = memo(ForwardRef);
export default IconUpdateArrow;
